<template>
  <component
    :is="mode"
    header="Header"
    footer="Footer"
    :class="{ 'p-sidebar-lg p-sidebar-close': mode == 'PSidebar' }"
    :dismissable="true"
    :visible.sync="showViewer"
    :modal="false"
    :position="mode == 'PSidebar' ? ($screen.breakpoint == 'sm' ? 'full' : 'right') : ''"
    :containerStyle="{
      width: width != null ? width : mode == 'PSidebar' ? '85vw' : '40vw',
    }"
  >
    <PCard class="shadow-0 border-0">
      <template #title>
        <div class="d-flex justify-content-between align-items mt-4">
          <slot name="headerLeft" :title="title">
            <h4 class="">{{ title }}</h4>
          </slot>
          <div class="d">
            <slot name="headerRight"></slot>
            <PButton
              @click.stop="hide"
              icon="pi pi-times"
              class="p-button-outlined p-button-rounded p-button-sm ms-2"
            />
          </div>
        </div>
        <PDivider />
      </template>
      <template #content>
        <slot :item="item" :title="title">No content</slot>
      </template>
    </PCard>
  </component>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    item: {
      type: [Object, Array],
      required: true,
    },
    width: {
      type: String,
    },
    mode: {
      type: String,
      default: "PSidebar",
    },
  },
  computed: {},
  data() {
    return {
      showViewer: false,
    };
  },
  created() {},
  methods: {
    hide() {
      this.$emit("close");
      this.showViewer = false;
    },
    show() {
      this.showViewer = true;
    },
  },
};
</script>

<style>
.p-sidebar-header {
  display: none;
}
</style>
